import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import { RouterProvider } from './context';

const Wrapper: React.FC<WithRouterProps> = ({
  children,
  location,
  router,
  params,
}) => {
  // memoize the object to not cause unnecessary rerenderings for context consumers
  const value = React.useMemo(
    () => ({ location, router, params }),
    [location, router, params],
  );

  return <RouterProvider value={value}>{children}</RouterProvider>;
};

export default withRouter(Wrapper);
